import { StyleSheet, View } from 'react-native'
import Animated from 'react-native-reanimated'

import { LoadingSpinner } from '../components/LoadingSpinner'
import { useFunkitTranslation } from '../providers/FunkitI18nProvider'
import { useTheme } from '../theme/restyle'
import { INDICATOR_ENTERING } from '../utils/motion'

const SPINNER_SIZE = 64

export function FiatSubmissionIndicator() {
  const theme = useTheme()
  const { t } = useFunkitTranslation()
  return (
    <Animated.View entering={INDICATOR_ENTERING}>
      <View
        accessibilityRole="progressbar"
        accessibilityLabel={t('common.loading')}
        style={styles.slot}
      >
        <LoadingSpinner size={SPINNER_SIZE} color={theme.brand.primary} />
      </View>
    </Animated.View>
  )
}

const styles = StyleSheet.create({
  slot: { height: 56, alignItems: 'center', justifyContent: 'center' },
})
